import { Reducer } from 'redux';
import { LayoutActionTypes, LayoutState } from './types';
import { SharedActionTypes } from '../shared/types';

const initialState: LayoutState = {
  selectedSection: null,
  navbarDropdown: false
};

const reducer: Reducer<LayoutState> = (state = initialState, action) => {
  switch (action.type) {
    case LayoutActionTypes.SECTION_VIEW_SELECTED: {
      const sectionTitle = action.payload;

      return {
        ...state,
        selectedSection: sectionTitle
      };
    }
    case LayoutActionTypes.SHOW_NAVBAR: {
      return { ...state, navbarDropdown: true };
    }
    case LayoutActionTypes.HIDE_NAVBAR: {
      return { ...state, navbarDropdown: false };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export { reducer as LayoutReducer };



// WEBPACK FOOTER //
// ./src/store/layout/reducer.ts